import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-box-layout',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './box-layout.component.html',
  styleUrl: './box-layout.component.scss'
})
export class BoxLayoutComponent {

}
